'use client';

import { Box, Text, Flex } from '@chakra-ui/react';
import { useParams } from 'next/navigation';
import { FaFacebook, FaFacebookMessenger, FaLinkedin, FaWhatsapp } from 'react-icons/fa6';

import PrintLink from './printLink';

import { Link } from '@ui/link';

export default function ShareLinks() {
  const { slug } = useParams<{
    slug: string;
  }>();

  const location =
    typeof window !== 'undefined'
      ? encodeURIComponent(window.location.href)
      : encodeURIComponent(`https://www.fauconis.fr/guide-mutuelles/article/${slug}`);

  return (
    <Box
      as="aside"
      mt="12"
      css={{
        '@media print': {
          display: 'none',
        },
      }}
    >
      <Text fontSize="lg" fontWeight="bold" mb="4" color="primary.dark">
        Partager sur
      </Text>
      <Flex gap="4" justifyContent="space-between" flexWrap="wrap">
        {/* LinkedIn */}
        <Link href={`https://www.linkedin.com/shareArticle?mini=true&url=${location}`} target="_blank">
          <FaLinkedin /> <Text color="fg">Linkedin</Text>
        </Link>

        {/* Facebook */}
        <Link href={`https://www.facebook.com/sharer/sharer.php?u=${location}`} target="_blank">
          <FaFacebook /> <Text color="fg">Facebook</Text>
        </Link>
        {/* Messenger */}
        <Link
          href={`https://www.facebook.com/dialog/send?app_id=123456789&link=${encodeURIComponent(
            location,
          )}&redirect_uri=${location}`}
          target="_blank"
        >
          <FaFacebookMessenger /> <Text color="fg">Messenger</Text>
        </Link>
        {/* Whatsapp */}
        <Link href={`https://api.whatsapp.com/send?text=${location}`} target="_blank">
          <FaWhatsapp /> <Text color="fg">Whatsapp</Text>
        </Link>

        <PrintLink />
      </Flex>
    </Box>
  );
}
